"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardizeSafeTransaction = void 0;
const constants_1 = require("../constants");
const gas_1 = require("./gas");
const SafeTransaction_1 = require("./SafeTransaction");
async function standardizeSafeTransaction(contract, tx) {
    var _a, _b, _c, _d, _e;
    const standardizedTxs = {
        to: tx.to,
        value: tx.value,
        data: tx.data,
        operation: (_a = tx.operation) !== null && _a !== void 0 ? _a : SafeTransaction_1.OperationType.Call,
        baseGas: (_b = tx.baseGas) !== null && _b !== void 0 ? _b : 0,
        gasPrice: (_c = tx.gasPrice) !== null && _c !== void 0 ? _c : 0,
        gasToken: tx.gasToken || constants_1.ZERO_ADDRESS,
        refundReceiver: tx.refundReceiver || constants_1.ZERO_ADDRESS,
        nonce: (_d = tx.nonce) !== null && _d !== void 0 ? _d : (await contract.nonce()).toNumber()
    };
    const safeTxGas = (_e = tx.safeTxGas) !== null && _e !== void 0 ? _e : (await gas_1.estimateTxGas(contract, standardizedTxs.to, standardizedTxs.value, standardizedTxs.data, standardizedTxs.operation));
    return {
        ...standardizedTxs,
        safeTxGas
    };
}
exports.standardizeSafeTransaction = standardizeSafeTransaction;
//# sourceMappingURL=utils.js.map